module.exports = __webpack_public_path__ + "static/media/mobileScreenshot01.63242a36.jpg";